// FORMATEAR NUMERO CON COMAS:
export const formatearNumeroConComas = (numero) => {
    return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  
  
  // FORMATEAR NUMERO CON PUNTOS:
  export const formatearNumeroConPuntos = (numero) => {
    return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };